module.exports = __webpack_public_path__ + "img/c5aa70640c3c4edf15d32a18dc9cf1e0.svg";